import {Component} from 'react'
import PropTypes from 'prop-types'
import {Modal as BootstrapModal, ModalBody, ModalHeader} from 'reactstrap'
import Check from 'react-feather/dist/icons/check.js'

const MODAL_CLASS_NAME = 'complete-profile-confirm-modal'
const TITLE_ID = 'complete-profile-confirm-modal-title'

export default class CompleteProfileConfirmModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    freelanceFullName: PropTypes.string,
    checklist: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      valid: PropTypes.bool,
    })),
    onConfirm: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  }

  static defaultProps = {
    checklist: [],
  }

  state = {
    loading: false,
    error: null,
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.setState({loading: false, error: null})
    }
  }

  handleConfirm = async () => {
    this.setState({loading: true, error: null})
    try {
      await this.props.onConfirm()
      this.props.onClose()
    } catch (e) {
      this.setState({
        loading: false,
        error: 'Une erreur est survenue lors de la mise à jour. Veuillez réessayer.',
      })
    }
  }

  handleClose = () => {
    if (this.state.loading) {
      return
    }
    this.props.onClose()
  }

  handleOpened = () => {
    const node = document.querySelector(`.${MODAL_CLASS_NAME}`)
    if (node) {
      node.setAttribute('aria-modal', 'true')
    }
  }

  render() {
    const {isOpen, freelanceFullName, checklist} = this.props
    const {loading, error} = this.state

    return (
      <BootstrapModal
        isOpen={isOpen}
        toggle={this.handleClose}
        keyboard={true}
        trapFocus={true}
        modalClassName={MODAL_CLASS_NAME}
        labelledBy={TITLE_ID}
        onOpened={this.handleOpened}
      >
        <ModalHeader toggle={this.handleClose} id={TITLE_ID}>
          Profil complet
        </ModalHeader>
        <ModalBody>
          <p className="mb-2">
            🎉 Félicitations, ce consultant <strong>{freelanceFullName}</strong> a rempli toutes les conditions ci-dessous.
            Souhaitez-vous passer ce profil <strong>Complet</strong> ?
          </p>
          <ul>
            {checklist.map((item) => (
              <li key={item.key} className="d-flex align-items-center text-success">
                <Check size={16} className="mr-2" />
                {item.label}
              </li>
            ))}
          </ul>
          {error && (
            <div className="text-danger mt-3" role="alert">
              {error}
            </div>
          )}
          <div className="d-flex justify-content-around mt-5">
            <button onClick={this.handleClose} disabled={loading} type="button" className="btn btn-outline-secondary">
              Plus tard
            </button>
            <button onClick={this.handleConfirm} disabled={loading} type="button" className="btn btn-secondary">
              {loading ? 'Traitement...' : 'Oui, passer en complet'}
            </button>
          </div>
        </ModalBody>
      </BootstrapModal>
    )
  }
}
